import { styled } from '@mui/material/styles';
import { List, ListItem } from '@mui/material';

export const StyledList = styled(List)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  
  '& .MuiListItemButton-root': {
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0.25, 0.5),
    
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.selected,
      
      '&:hover': {
        backgroundColor: theme.palette.action.selected,
      },
    },
    
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
  
  '& .MuiListItemIcon-root': {
    minWidth: '40px',
    color: theme.palette.text.secondary,
  },
  
  '& .MuiListItemText-root': {
    margin: 0,
    
    '& .MuiListItemText-primary': {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.text.primary,
    },
    
    '& .MuiListItemText-secondary': {
      fontSize: theme.typography.body2.fontSize,
      color: theme.palette.text.secondary,
    },
  },
  
  '& .MuiListItemAvatar-root': {
    minWidth: '56px',
  },
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: 0,
  
  '&.MuiListItem-dense': {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
  },
})); 